import { render, staticRenderFns } from "./DesignTab.vue?vue&type=template&id=6030f124&scoped=true"
import script from "./DesignTab.vue?vue&type=script&lang=js"
export * from "./DesignTab.vue?vue&type=script&lang=js"
import style0 from "./DesignTab.vue?vue&type=style&index=0&id=6030f124&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6030f124",
  null
  
)

export default component.exports